var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermax2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 846 139",
    width: 846,
    height: 139,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "THERMAX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #000000 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "s0",
    d: "m717.6-0.5h27.7l35.3 47.7 33.4-47.7h30.5l-49.6 68.7 49.6 70.6h-30.5l-33.4-47.7-35.3 47.7h-27.7l48.7-70.6zm-42.9 0l53.4 112.6-20 26.7-17.2-35.3h-47.7l-17.2 35.3h-28.6l60.1-139.3zm-21 77.3h28.6l-14.3-40.1zm-216.6-77.3h35.3l37.2 105.9 40.1-105.9h35.3v139.3h-27.7v-104l-35.3 104h-20l-38.2-104v104h-26.7zm-56.3-0.2l11.4 2 6.7 2.9 5.7 3.8 4.8 4.8 3.8 2.9 3.8 6.7 2.9 6.7 1 7.6 1 6.7-1 5.7-1 6.7-2.9 6.7-3.8 5.7-13.4 11.4-6.7 3.8-7.6 2.9 36.3 52.5h-31.5l-37.2-54.4v54.4h-27.7v-139.3h40.1zm-27.6 64.1h16.2l10.5-1 7.6-3.8 4.8-5.7 1.9-9.5-1.9-8.6-4.8-5.7-8.6-3.8-11.5-1h-14.3zm-48.8-63.9v24.8h-51.5v33.4h47.7v22.9h-47.7v31.5h49.6v26.7h-76.3v-139.3zm-180.3 0v56.3h49.6v-56.3h26.7v139.3h-26.7v-60.1h-49.6v60.1h-27.7v-139.3zm-121.2 0h81.1v24.8h-24.8v114.5h-26.7v-114.5h-29.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermax2);
export default __webpack_public_path__ + "static/media/THERMAX-2.47cd969086fc18ee81a81695d168806b.svg";
export { ForwardRef as ReactComponent };